export enum VisualisationActionsType {
    settings = 'settings',
    catalog = 'catalog',
}
